import { Directive, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[bnNgInit]',
})
export class BbNgInit {
  @Output() bnNgInit: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.bnNgInit.emit();
  }
}
